import Vue from 'vue'
import VueRouter from 'vue-router'
import Inicio from '@/views/Inicio.vue'
// resolver .. --> @

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: Inicio
  },
  {
    path: '/repositorio',
    name: 'Repositorio',
    component: () => import('@/views/Repositorio.vue')
  },
  {
    path: '/mapas',
    name: 'Mapas',
    component: () => import('@/views/Mapas.vue')
  },
  {
    path: '/datos',
    name: 'Bases de Datos',
    component: () => import('@/views/Datos.vue')
  },
  //{
  //  path: '/coordinacion',
  //  name: 'Coordinación Gubernamental',
  //  component: () => import('@/views/Coordinacion.vue')
  //},
  {
    path: '/regulacion',
    name: 'Regulación',
    component: () => import('@/views/Regulacion.vue')
  },
  {
    path: '/comunicacion',
    name: 'Comunicación',
    component: () => import('@/views/Comunicacion.vue')
  },
  {
    path: '/alternativas',
    name: 'Alternativas',
    component: () => import('@/views/Alternativas.vue'),
    //Las subsecciones de alternativas
    children:[
      {
        path:'',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/Introduccion.vue')
      },
      {
        path:'principios-manejo-ecologico-arvenses-articulos',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/PrincipiosArvensesArticulos.vue')
      },
      {
        path:'principios-manejo-ecologico-arvenses-materiales',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/PrincipiosArvensesMateriales.vue')
      },
      {
        path:'principios-manejo-ecologico-arvenses-manuales',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/PrincipiosArvensesManuales.vue')
      },
      {
        path:'practicas-especiales-articulos',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/PracticasEspecialesArticulos.vue')
      },
      {
        path:'practicas-especiales-materiales',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/PracticasEspecialesMateriales.vue')
      },
      {
        path:'practicas-especiales-mapa',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/PracticasEspecialesMapa.vue')
      },
      {
        path:'enlaces',
        name: 'Alternativas',
        component: () => import('@/views/alternativas/Enlaces.vue')
      }
    ]
  },
  {
    path: '/impacto',
    name: 'Impacto',
    component: () => import('@/views/Impacto.vue')
  },
  {
    path: '/ayuda',
    name: 'Ayuda',
    component: () => import('@/views/Ayuda.vue')
  },
  {
    path: '**',
    name: 'Página no encontrada',
    component: () => import('@/views/PageNotFound.vue')
    //component: () => import('@/views/404.vue') // baseweb
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

export default router
